import { PanelRightCloseIcon } from 'icons/PanelRightCloseIcon';
import { PanelRightOpenIcon } from 'icons/PanelRightOpenIcon';

import styles from '../DisplaySidebar.module.css';

import { useEffect, useRef } from 'react';
import { forwardRef } from 'react';
import { COLOR_JAUGE, PIXLINK_STATUS } from 'utils/Constants';
import { MyCustomHighcharts } from 'components/shared/Charts/MyCustomHighcharts';
import { calculateClientMinimumLinks, calculateMinimumLinks } from 'utils/netlinking/linksNumber';
import { calculateBudgetCampaignPixalione, calculateRefusedClient, calculateRefusedPixalione, calculateToBeCommanded, calculateToBeFilteredConsultant, calculateValidateClient, calculateValidateSuperAdmin, calculateValidateSuperConsultant } from 'utils/Jauge/Calculate';
import { MyCustomReverseHighChats } from 'components/shared/Charts/MyCustomReverseHighChats';
import { MyCustomProgressBarSmall } from 'components/shared/Charts/MyCustomProgressBarSmall';
import { MyCustomBiggerReverseHighChats } from 'components/shared/Charts/MyCustomBiggerReverseHighChats';
export const SuperAdminDisplaySidebar = forwardRef(
    (
        {
            collapsed,
            setCollapsed,
            width = 400,
            minWidth = 400,
            maxWidth = 500,
            setWidth,
            nbrOfLinksDemanded,
            t,
            netlinkings,
            netlinkingsTmp,
            campaignBudget,
            otherCampaignTarif,
            finished
        },
        ref
    ) => {
        const isResizing = useRef(false);

        const handleMouseDown = () => {
            isResizing.current = true;
            document.body.classList.add('resizing');
        };

        const handleMouseMove = (event) => {
            if (!isResizing.current || collapsed) return;

            document.body.classList.add('resizing');

            const calculatedWidth = window.innerWidth - event.clientX;
            const newWidth = Math.min(maxWidth, Math.max(minWidth, calculatedWidth));

            setWidth(newWidth);
        };

        const handleMouseUp = () => {
            isResizing.current = false;
            document.body.classList.remove('resizing');
        };

        useEffect(() => {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);

            return () => {
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
            };
        }, []);

        return (
            <>
                <button
                    className={styles.sidebarToggleButton}
                    style={{
                        right: collapsed ? 5 : width + 5,
                    }}
                    onClick={() => setCollapsed(!collapsed)}
                >
                    {collapsed ? (
                        <PanelRightOpenIcon width={28} height={28} />
                    ) : (
                        <PanelRightCloseIcon width={28} height={28} />
                    )}
                </button>

                <div
                    className={styles.sidebar}
                    style={{
                        width: collapsed ? 0 : width,
                    }}
                >
                    <div onMouseDown={handleMouseDown} className={styles.resizeHandler} />
                    <div ref={ref} className={styles.sidebarContent}>

                        <div className="box-wrapper" >
                            <div className="header-title mb-0">
                                {t('Nombre de liens proposé')}
                            </div>
                            <div className="sub-header-title">
                                {nbrOfLinksDemanded < 16
                                    ? t('(Nombre de liens commandés * 2)')
                                    : nbrOfLinksDemanded < 70
                                        ? t('(Nombre de liens commandés + 15)')
                                        : t('(Nombre de liens commandés + 30)')}
                            </div>
                            <div className="box-graph">
                                <div className="d-flex justify-content-center">
                                    {nbrOfLinksDemanded > 0 ? (
                                        <MyCustomHighcharts
                                            value={
                                                netlinkingsTmp.length > 0
                                                    ? netlinkingsTmp.filter(
                                                        (item) =>
                                                            item.spotStatus !==
                                                            PIXLINK_STATUS.REFUSED_PIXALIONE
                                                    ).length
                                                    : netlinkings.filter(
                                                        (item) =>
                                                            item.spotStatus !==
                                                            PIXLINK_STATUS.REFUSED_PIXALIONE
                                                    ).length
                                            }
                                            maxValue={calculateMinimumLinks(nbrOfLinksDemanded)}
                                        ></MyCustomHighcharts>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        {(netlinkings.filter(
                            (item) =>
                                item.spotStatus !== 'TO_DEFINE' &&
                                item.spotStatus !== null &&
                                item.spotStatus !== undefined
                        ).length > 0 && !finished) && (
                                <div >
                                    <div className="box-wrapper" >
                                        <div className="header-title mb-0">
                                            {t('Nombre de liens par Status')}
                                        </div>
                                        <div className="box-graph">
                                            <div className="d-flex justify-content-center">
                                                {nbrOfLinksDemanded > 0 ? (
                                                    <span>
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                flexDirection: 'row',
                                                                flexWrap: 'wrap',
                                                            }}
                                                        >
                                                            {(calculateValidateSuperAdmin(netlinkings) > 0 || true) && (
                                                                <MyCustomProgressBarSmall
                                                                    defaultColor={COLOR_JAUGE.GREY}
                                                                    label={t('A  valider Super admin')}
                                                                    value={calculateValidateSuperAdmin(netlinkings)}
                                                                    maxValue={calculateMinimumLinks(
                                                                        nbrOfLinksDemanded
                                                                    )}
                                                                ></MyCustomProgressBarSmall>
                                                            )}
                                                            {(calculateValidateSuperConsultant(netlinkings) >
                                                                0 || true) && (
                                                                    <MyCustomProgressBarSmall
                                                                        defaultColor={COLOR_JAUGE.BLACK}
                                                                        label={t('A  valider Super consultant')}
                                                                        value={calculateValidateSuperConsultant(
                                                                            netlinkings
                                                                        )}
                                                                        maxValue={calculateMinimumLinks(
                                                                            nbrOfLinksDemanded
                                                                        )}
                                                                    ></MyCustomProgressBarSmall>
                                                                )}
                                                            {(calculateValidateClient(netlinkings) > 0 || true) && (
                                                                <MyCustomProgressBarSmall
                                                                    defaultColor={COLOR_JAUGE.ORANGE}
                                                                    label={t('A  valider client')}
                                                                    value={calculateValidateClient(netlinkings)}
                                                                    maxValue={calculateMinimumLinks(
                                                                        nbrOfLinksDemanded
                                                                    )}
                                                                ></MyCustomProgressBarSmall>
                                                            )}
                                                            {(calculateToBeFilteredConsultant(netlinkings) > 0 || true) && (
                                                                <MyCustomProgressBarSmall
                                                                    defaultColor={COLOR_JAUGE.BLUE}
                                                                    label={t('Validé client')}
                                                                    value={calculateToBeFilteredConsultant(
                                                                        netlinkings
                                                                    )}
                                                                    maxValue={calculateMinimumLinks(
                                                                        nbrOfLinksDemanded
                                                                    )}
                                                                ></MyCustomProgressBarSmall>
                                                            )}
                                                            {(calculateToBeCommanded(netlinkings) > 0 || true) && (
                                                                <MyCustomProgressBarSmall
                                                                    label={t('A commander')}
                                                                    defaultColor={COLOR_JAUGE.GREEN}
                                                                    value={calculateToBeCommanded(netlinkings)}
                                                                    maxValue={calculateMinimumLinks(
                                                                        nbrOfLinksDemanded
                                                                    )}
                                                                ></MyCustomProgressBarSmall>
                                                            )}
                                                            {(calculateRefusedClient(netlinkings) > 0 || true) && (
                                                                <MyCustomProgressBarSmall
                                                                    label={t('Refusé client')}
                                                                    defaultColor={COLOR_JAUGE.RED}
                                                                    value={calculateRefusedClient(netlinkings)}
                                                                    maxValue={calculateMinimumLinks(
                                                                        nbrOfLinksDemanded
                                                                    )}
                                                                ></MyCustomProgressBarSmall>
                                                            )}
                                                            {(calculateRefusedPixalione(netlinkings) > 0 || true) && (
                                                                <MyCustomProgressBarSmall
                                                                    label={t('Refusé Pixalione')}
                                                                    defaultColor={COLOR_JAUGE.VIOLET}
                                                                    value={calculateRefusedPixalione(netlinkings)}
                                                                    maxValue={calculateMinimumLinks(
                                                                        nbrOfLinksDemanded
                                                                    )}
                                                                ></MyCustomProgressBarSmall>
                                                            )}
                                                        </div>
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {(<div className="box-wrapper" >
                            <div className="header-title mb-0">
                                {t('Reste à consommer')}
                            </div>
                            <div className="box-graph">
                                <div className="d-flex justify-content-center">
                                    <span>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <MyCustomBiggerReverseHighChats
                                                defaultColor="#FF8D4B"
                                                value={parseFloat(campaignBudget) - (calculateBudgetCampaignPixalione(netlinkings) + otherCampaignTarif)
                                                }
                                                maxValue={campaignBudget}
                                            ></MyCustomBiggerReverseHighChats>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>)}
                        <div className="box-wrapper" >
                            <div className="header-title mb-0">
                                {t('Quota de refus disponible')}
                            </div>
                            <div className="sub-header-title">
                                {t('((Nombre de liens proposé-Nombre de liens demandés)/2)')} :
                            </div>
                            <div className="box-graph">
                                <div className="d-flex justify-content-center">
                                    {nbrOfLinksDemanded > 0 ? (
                                        <span>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <MyCustomReverseHighChats
                                                    defaultColor="#FF8D4B"
                                                    value={
                                                        netlinkings.filter(
                                                            (item) =>
                                                                item.spotStatus ===
                                                                PIXLINK_STATUS.REFUSED_CLIENT ||
                                                                item.spotTmpStatus ===
                                                                PIXLINK_STATUS.REFUSED_CLIENT
                                                        ).length
                                                    }
                                                    maxValue={Math.floor(
                                                        calculateMinimumLinks(nbrOfLinksDemanded) -
                                                        calculateClientMinimumLinks(nbrOfLinksDemanded)
                                                    )}
                                                ></MyCustomReverseHighChats>
                                            </div>
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                        </div>




                    </div >
                </div >
            </>
        );
    }
);

export default SuperAdminDisplaySidebar;
